module.exports = __webpack_public_path__ + "static/img/7a7146e3b4499d9eab014a893dba9b82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/图片4.png
// module id = i089
// module chunks = 1